<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span>{{ 'modals.survey-reports.title' | translate }}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" type="button" (click)="close()" [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<div class="reports-hub">
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    @if (activeReport; as active) {
      <div class="hub-card hub-card-active">
        <div class="hub-card-icon">
          <mat-spinner diameter="26" strokeWidth="3"></mat-spinner>
        </div>
        <div class="hub-card-body">
          <div class="hub-card-title">
            {{ 'modals.survey-reports.active-title' | translate }}
            <span class="status-chip status-chip-{{ active.status | lowercase }}">{{ 'modals.survey-report-progress.status-' + (active.status | lowercase) | translate }}</span>
          </div>
          <div class="hub-card-meta">
            {{ 'modals.survey-reports.requested' | translate: { date: (active.created_at | date: 'dd/MM/yyyy HH:mm'), user: active.requested_by || '–' } }}
          </div>
          <mat-progress-bar class="mt-2" [mode]="active.status === 'PROCESSING' && active.progress_total > 0 ? 'determinate' : 'indeterminate'" [value]="progressPercent(active)"></mat-progress-bar>
          @if (active.status === 'PROCESSING' && active.progress_total > 0) {
            <div class="hub-card-meta mt-1">{{ 'modals.survey-report-progress.build-progress' | translate: { done: active.progress_done, total: active.progress_total } }}</div>
          }
        </div>
        <div class="hub-card-actions">
          <button mat-stroked-button color="primary" type="button" (click)="openDetails(active)">
            <mat-icon>timeline</mat-icon>
            {{ 'modals.survey-reports.details' | translate }}
          </button>
          <button mat-button class="hub-cancel-button" type="button" (click)="openDetails(active, true)">
            <mat-icon>stop_circle</mat-icon>
            {{ 'modals.survey-report-progress.cancel' | translate }}
          </button>
        </div>
      </div>
    } @else {
      <div class="hub-card hub-card-generate">
        <div class="hub-card-icon hub-card-icon-generate">
          <mat-icon>slideshow</mat-icon>
        </div>
        <div class="hub-card-body">
          <div class="hub-card-title">{{ 'modals.survey-reports.generate-title' | translate }}</div>
          <div class="hub-card-meta">{{ 'modals.survey-reports.generate-hint' | translate }}</div>
        </div>
        <div class="hub-card-actions">
          <button mat-flat-button color="primary" type="button" (click)="generate()">
            <mat-icon>add</mat-icon>
            {{ 'modals.survey-reports.generate' | translate }}
          </button>
        </div>
      </div>
    }

    <div class="hub-section-head">
      <h6 class="hub-section-title">{{ 'modals.survey-reports.history' | translate }}</h6>
      @if (history.length > 0) {
        <span class="hub-section-count">{{ history.length }}</span>
      }
    </div>

    @if (failed) {
      <p class="text-danger small mb-0">{{ 'modals.survey-reports.load-error' | translate }}</p>
    } @else if (history.length === 0) {
      <div class="hub-empty">
        <mat-icon>history</mat-icon>
        <span>{{ 'modals.survey-reports.history-empty' | translate }}</span>
      </div>
    } @else {
      <div class="hub-table-wrapper">
        <table class="hub-table">
          <thead>
            <tr>
              <th>{{ 'modals.survey-reports.col-date' | translate }}</th>
              <th>{{ 'modals.survey-reports.col-requested-by' | translate }}</th>
              <th>{{ 'modals.survey-reports.col-status' | translate }}</th>
              <th class="text-right">{{ 'modals.survey-reports.col-duration' | translate }}</th>
              <th class="text-center">{{ 'modals.survey-reports.col-language' | translate }}</th>
              <th class="text-right">{{ 'modals.survey-reports.col-actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (report of history; track report.id) {
              <tr>
                <td class="hub-date">
                  <div>{{ report.created_at | date: 'dd/MM/yyyy' }}</div>
                  <div class="hub-time">{{ report.created_at | date: 'HH:mm' }}</div>
                </td>
                <td class="hub-user">{{ report.requested_by || '–' }}</td>
                <td>
                  <span class="status-chip status-chip-{{ report.status | lowercase }}"
                    [matTooltip]="report.status === 'FAILED' ? (report.error_message || '') : ''">
                    {{ 'modals.survey-report-progress.status-' + (report.status | lowercase) | translate }}
                  </span>
                </td>
                <td class="text-right hub-muted">{{ duration(report) }}</td>
                <td class="text-center hub-muted">{{ (report.options?.language || '–') | uppercase }}</td>
                <td class="text-right hub-actions">
                  <button mat-icon-button type="button" (click)="openDetails(report)" [matTooltip]="'modals.survey-reports.details' | translate">
                    <mat-icon>timeline</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" type="button" [disabled]="report.status !== 'COMPLETED'" (click)="download(report)"
                    [matTooltip]="'modals.survey-reports.download' | translate">
                    <mat-icon>file_download</mat-icon>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  }
</div>

<div class="buttons-container container mb-3 d-flex justify-content-end">
  <button mat-stroked-button class="text-dark-purple border-purple" type="button" (click)="close()">
    {{ 'generic.buttons.close' | translate }}
  </button>
</div>
